import React from 'react';
import { 
    Box, 
    Typography, 
    FormControlLabel, 
    Checkbox,
    Paper
} from '@mui/material';
import { SproutingData } from '../../Types/InspectionTypes';

interface SproutingSectionProps {
    sprouting: SproutingData;
    onUpdate: (field: keyof SproutingData, value: boolean) => void;
    isMobile?: boolean;
}

const SproutingSection: React.FC<SproutingSectionProps> = ({ sprouting, onUpdate, isMobile = false }) => {
    return (
        <Paper 
            elevation={0} 
            sx={{ 
                p: isMobile ? 1.5 : 2, 
                mb: isMobile ? 1.5 : 2, 
                backgroundColor: 'action.hover',
                border: '1px solid',
                borderColor: 'divider'
            }}
        >
            <Typography 
                variant={isMobile ? "caption" : "subtitle2"} 
                sx={{ mb: 1, fontWeight: 600, color: 'text.primary' }}
            >
                Sprouting
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: isMobile ? 0.5 : 1 }}>
                <FormControlLabel
                    control={
                        <Checkbox 
                            checked={sprouting.none}
                            onChange={(e) => onUpdate('none', e.target.checked)}
                            size="small"
                        />
                    }
                    label={<Typography variant={isMobile ? "caption" : "body2"}>None</Typography>}
                    sx={{ mr: isMobile ? 0.5 : 1 }}
                />
                <FormControlLabel
                    control={
                        <Checkbox 
                            checked={sprouting.controlled}
                            onChange={(e) => onUpdate('controlled', e.target.checked)}
                            size="small"
                        />
                    }
                    label={<Typography variant={isMobile ? "caption" : "body2"}>Controlled</Typography>}
                    sx={{ mr: isMobile ? 0.5 : 1 }}
                />
                <FormControlLabel
                    control={
                        <Checkbox 
                            checked={sprouting.eyesOpen}
                            onChange={(e) => onUpdate('eyesOpen', e.target.checked)}
                            size="small"
                        />
                    }
                    label={<Typography variant={isMobile ? "caption" : "body2"}>Eyes Open</Typography>}
                    sx={{ mr: isMobile ? 0.5 : 1 }}
                />
                <FormControlLabel
                    control={
                        <Checkbox 
                            checked={sprouting.buds}
                            onChange={(e) => onUpdate('buds', e.target.checked)}
                            size="small"
                        />
                    }
                    label={<Typography variant={isMobile ? "caption" : "body2"}>Buds</Typography>}
                    sx={{ mr: isMobile ? 0.5 : 1 }}
                />
                <FormControlLabel
                    control={
                        <Checkbox 
                            checked={sprouting.peeping}
                            onChange={(e) => onUpdate('peeping', e.target.checked)}
                            size="small"
                        />
                    }
                    label={<Typography variant={isMobile ? "caption" : "body2"}>Peeping</Typography>}
                    sx={{ mr: isMobile ? 0.5 : 1 }}
                />
                <FormControlLabel
                    control={
                        <Checkbox 
                            checked={sprouting.lessThanHalfIn}
                            onChange={(e) => onUpdate('lessThanHalfIn', e.target.checked)}
                            size="small"
                        />
                    }
                    label={<Typography variant={isMobile ? "caption" : "body2"}>{"< 1/2 in"}</Typography>}
                    sx={{ mr: isMobile ? 0.5 : 1 }}
                />
                <FormControlLabel
                    control={
                        <Checkbox 
                            checked={sprouting.greaterThanHalfIn}
                            onChange={(e) => onUpdate('greaterThanHalfIn', e.target.checked)}
                            size="small"
                        />
                    }
                    label={<Typography variant={isMobile ? "caption" : "body2"}>{"> 1/2 in"}</Typography>}
                    sx={{ mr: isMobile ? 0.5 : 1 }}
                />
            </Box>
        </Paper>
    );
};

export default SproutingSection;
